import React from 'react';
import { Switch, Route } from 'react-router-dom';

import http from 'api/http';
import { componentFamilyAPI, componentAPI, boatAPI } from 'api/requests';

import WithUser from 'HOC/User';

import { ACTION, STATUS } from '../../constants';
import { ROLES } from 'constants/roles';

import List from './List';
import Application from './Application';
import Family from './ComponentFamily';
import FamiliesList from './FamilyList';
import NotificationManager from 'dom-managers/notification';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';
import Store from '../../../registerIDBWorker';

@WithUser
export default class ComponentManufacturer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      types: '',
      categories: '',
      families: '',
      components: '',
      componentsRequestInProcess: true,
      familiesRequestInProcess: true,
      requestInProcess: false,
      currentModelYear: new Date().getFullYear(),
    };

    this.componentsRequestIndex = 0;
    this.familiesRequestIndex = 0;
  }

  roleSwitch = () => {
    const { user } = this.props;
    if (user.getActiveRole() !== ROLES.COMPONENT_MANUFACTURER.serverName) {
      user.changeMenu(ROLES.COMPONENT_MANUFACTURER.serverName);
    }
  };

  componentDidMount() {
    this.roleSwitch();
    this.updateListData();

    http.get(componentAPI.types).then(({ data }) => {
      this.setState({ types: data });
    });

    http.get(componentAPI.categories).then(({ data }) => {
      this.setState({ categories: data });
    });

    http.get(boatAPI.currentModelYear).then(({ data }) => {
      this.setState({ currentModelYear: data[1] || data[0] });
    });
  }

  updateListData = () => {
    const { user } = this.props;
    const { familiesRequestInProcess, componentsRequestInProcess } = this.state;

    if (familiesRequestInProcess) ++this.familiesRequestIndex;
    else this.familiesRequestIndex = 0;
    const familiesRequestIndex = this.familiesRequestIndex;

    this.setState({ familiesRequestInProcess: true }, () => {
      http.get(componentFamilyAPI.list).then(({ data: familiesList }) => {
        if (familiesRequestIndex >= this.familiesRequestIndex) {
          Store.insert(`${user.getActiveRole()}_families_lists`, familiesList, user.getManufacturerCode()).then(() => {
            this.loadFromStore(() => {
              this.setState({ familiesRequestInProcess: false });
            });
          });
        }
      });
    });

    if (componentsRequestInProcess) ++this.componentsRequestIndex;
    else this.componentsRequestIndex = 0;
    const componentsRequestIndex = this.componentsRequestIndex;

    this.setState({ componentsRequestInProcess: true }, () => {
      http.get(componentAPI.list).then(({ data: componentList }) => {
        if (componentsRequestIndex >= this.componentsRequestIndex) {
          Store.insert(`${user.getActiveRole()}_lists`, componentList, user.getManufacturerCode()).then(() => {
            this.loadFromStore(() => {
              this.setState({ componentsRequestInProcess: false });
            });
          });
        }
      });
    });
  };

  updateComponentListEntry = (oldEntry, newEntry) => {
    const { user } = this.props;

    if (typeof newEntry === 'string') {
      oldEntry.applicationStatus = newEntry;
      Store.insert(`${user.getActiveRole()}_lists`, oldEntry, user.getManufacturerCode());
    } else {
      Store.insert(`${user.getActiveRole()}_lists`, newEntry, user.getManufacturerCode());
    }

    this.loadFromStore();
    this.updateListData();
  };

  updateFamiliesListEntry = (oldEntry, newEntry) => {
    const { user } = this.props;

    if (typeof newEntry === 'string') {
      oldEntry.status = newEntry;
      Store.insert(`${user.getActiveRole()}_families_lists`, oldEntry, user.getManufacturerCode());
    } else {
      Store.insert(`${user.getActiveRole()}_families_lists`, newEntry, user.getManufacturerCode());
    }

    this.loadFromStore();
    this.updateListData();
  };

  loadFromStore = (cb = () => {}) => {
    const { user } = this.props;

    Store.select(`${user.getActiveRole()}_lists`, user.getManufacturerCode()).then(components => {
      this.setState({ components }, cb);
    });
    Store.select(`${user.getActiveRole()}_families_lists`, user.getManufacturerCode()).then(families => {
      this.setState({ families }, cb);
    });
  };

  createAvailableForThisStatusActionsList = componentStatus => {
    const { user } = this.props;
    const userIsInternal = user.isInternal();
    const actions = [ACTION.DETAILS, ACTION.EDIT];

    if (componentStatus === STATUS.DEACTIVATED) {
      actions.push(ACTION.REACTIVATE);
    }

    if (componentStatus === STATUS.PENDING || componentStatus === STATUS.APPROVED) {
      actions.push(ACTION.DEACTIVATE);
    }

    if (componentStatus === STATUS.PENDING && userIsInternal) {
      actions.push(ACTION.APPROVE);
    }

    if (userIsInternal && componentStatus !== STATUS.DEACTIVATED && componentStatus !== STATUS.INCOMPLETE) {
      actions.push(ACTION.INCOMPLETE);
    }

    if (componentStatus === STATUS.INCOMPLETE) {
      actions.push(ACTION.RESUBMIT);
    }

    return actions;
  };

  performActionFunction = (actionKey, actionSubjectId) => {
    const { user } = this.props;

    switch (actionKey) {
      case ACTION.DEACTIVATE:
        return new Promise((resolve, reject) => {
          this.modalBody = 'Are you sure you want to Deactivate this application?';
          this.modalConfirmAction = this._getChangeStatusAction(
            componentAPI.deactivate(actionSubjectId),
            STATUS.DEACTIVATED,
            resolve
          );
          this._openModal();
        });
      case ACTION.INCOMPLETE:
        return new Promise((resolve, reject) => {
          this.modalBody = 'Are you sure you want to mark this application as Incomplete?';
          this.modalConfirmAction = this._getChangeStatusAction(
            componentAPI.incomplete(actionSubjectId),
            STATUS.INCOMPLETE,
            resolve
          );
          this._openModal();
        });
      case ACTION.REACTIVATE:
        return new Promise((resolve, reject) => {
          this.modalBody = 'Are you sure you want to Reactivate this application?';
          this.modalConfirmAction = this._getChangeStatusAction(
            componentAPI.reactivate(actionSubjectId),
            STATUS.INCOMPLETE,
            resolve
          );
          this._openModal();
        });
      case ACTION.APPROVE:
        return new Promise((resolve, reject) => {
          this.modalBody = 'Are you sure you want to Approve this application?';
          this.modalConfirmAction = this._getChangeStatusAction(
            componentAPI.approve(actionSubjectId),
            STATUS.APPROVED,
            resolve
          );
          this._openModal();
        });
      case ACTION.RESUBMIT:
        return new Promise((resolve, reject) => {
          this.modalBody = 'Are you sure you want to Resubmit this application?';
          this.modalConfirmAction = this._getChangeStatusAction(
            componentAPI.submit(actionSubjectId),
            STATUS.PENDING,
            resolve
          );
          this._openModal();
        });
      case ACTION.DETAILS:
        return new Promise((resolve, reject) => {
          user.goTo(`/${user.getManufacturerCode()}/component/application/${actionSubjectId}/details`);
        });
      case ACTION.EDIT:
        return new Promise((resolve, reject) => {
          user.goTo(`/${user.getManufacturerCode()}/component/application/${actionSubjectId}/edit`);
        });
      default:
        return () => {
          NotificationManager.error('note', 'No such action');
        };
    }
  };

  createFamilyActionsList = familyStatus => {
    const { user } = this.props;
    const actions = [ACTION.DETAILS, ACTION.EDIT];

    if (user.isInternal()) {
      actions.push(ACTION.APPROVE);
    }
    return actions;
  };

  performFamilyActionFunction = (actionKey, actionSubjectId) => {
    const { user } = this.props;

    switch (actionKey) {
      case ACTION.APPROVE:
        return new Promise((resolve, reject) => {
          this.modalBody = 'Are you sure you want to approve all component applications in this component family?';
          this.modalConfirmAction = this._getChangeStatusAction(
            componentFamilyAPI.approve(actionSubjectId),
            STATUS.APPROVED,
            resolve
          );
          this._openModal();
        });
      case ACTION.DETAILS:
        return new Promise((resolve, reject) => {
          user.goTo(`${user.getFamiliesLink()}/${actionSubjectId}/details`);
        });
      case ACTION.EDIT:
        return new Promise((resolve, reject) => {
          user.goTo(`${user.getFamiliesLink()}/${actionSubjectId}/edit`);
        });
      default:
        return () => {
          NotificationManager.error('note', 'No such action');
        };
    }
  };

  _getChangeStatusAction = (api, newStatusString, cb) => () => {
    this.setState({ requestInProcess: true }, () => {
      http
        .patch(api)
        .then(({ data }) => {
          cb(data || newStatusString);
          NotificationManager.success(1, 'The status was updated successfully.');
        })
        .finally(this._closeModal);
    });
  };

  _openModal = () => {
    this.setState({ isModalOpen: true });
  };

  _closeModal = () => {
    this.setState({ isModalOpen: false, requestInProcess: false });
  };

  render() {
    const {
      isModalOpen,
      types,
      categories,
      families,
      components,
      componentsRequestInProcess,
      familiesRequestInProcess,
      requestInProcess,
      currentModelYear,
    } = this.state;
    const { match, user } = this.props;

    return (
      <React.Fragment>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={({ match }) => (
              <List
                match={match}
                createAvailableForThisStatusActionsList={this.createAvailableForThisStatusActionsList}
                performActionFunction={this.performActionFunction}
                user={user}
                types={types}
                categories={categories}
                families={families}
                components={components}
                currentModelYear={currentModelYear}
                componentsRequestInProcess={componentsRequestInProcess}
                familiesRequestInProcess={familiesRequestInProcess}
                updateComponentListEntry={this.updateComponentListEntry}
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/family`}
            render={({ match }) => (
              <FamiliesList
                match={match}
                createFamilyActionsList={this.createFamilyActionsList}
                performFamilyActionFunction={this.performFamilyActionFunction}
                updateFamiliesListEntry={this.updateFamiliesListEntry}
                user={user}
                types={types}
                categories={categories}
                families={families}
                components={components}
                componentsRequestInProcess={componentsRequestInProcess}
                familiesRequestInProcess={familiesRequestInProcess}
              />
            )}
          />
          <Route
            path={`${match.path}/family/:familyId`}
            render={({ match }) => (
              <Family
                match={match}
                createFamilyActionsList={this.createFamilyActionsList}
                performFamilyActionFunction={this.performFamilyActionFunction}
                updateFamiliesListEntry={this.updateFamiliesListEntry}
                user={user}
                types={types}
                categories={categories}
                families={families}
                components={components}
                componentsRequestInProcess={componentsRequestInProcess}
                familiesRequestInProcess={familiesRequestInProcess}
              />
            )}
          />
          <Route
            path={`${match.path}/application/:applicationId`}
            render={({ match }) => (
              <Application
                match={match}
                createAvailableForThisStatusActionsList={this.createAvailableForThisStatusActionsList}
                performActionFunction={this.performActionFunction}
                updateComponentListEntry={this.updateComponentListEntry}
                user={user}
                types={types}
                categories={categories}
                families={families}
                components={components}
                componentsRequestInProcess={componentsRequestInProcess}
                familiesRequestInProcess={familiesRequestInProcess}
              />
            )}
          />
        </Switch>

        <Modal isOpen={isModalOpen}>
          <div className='ect-modal-header'>Confirmation</div>
          <div className='ect-modal-body'>{this.modalBody}</div>
          <div className='ect-modal-footer'>
            <Button
              label='No'
              buttonClassName='_width_135 _height_40'
              onClick={this._closeModal}
              color={buttonColor.gray}
              type={buttonType.secondary}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_width_135 _height_40'
              onClick={this.modalConfirmAction}
            />
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/index.jsx